import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import useEffectOnLoad from '../hooks/useEffectOnLoad';
import { parseSsoCode } from '../utils/queryString';
import { loginSsoUser } from '../actions/authentication';
import Spinner from './Spinner';
import useAuthentication from '../hooks/useAuthentication';
import LoginPanel from './LoginPanel';

function SsoLogin() {
    const location = useLocation();
    const { isUserLoggedIn } = useAuthentication();
    const code = parseSsoCode(location.search);
    const dispatch = useDispatch();
    const [isAuthenticationInProgress, setAuthenticationInProgress] = useState(true);
    const authenticationFinished = () => setAuthenticationInProgress(false);
    useEffectOnLoad(() => {
        setAuthenticationInProgress(true);
        dispatch(loginSsoUser(code, authenticationFinished));
    });
    let result;
    if (isUserLoggedIn) {
        result = <Redirect to={(location.state && location.state.from) ? location.state.from : '/'} />;
    } else if (isAuthenticationInProgress) {
        result = <Spinner className="sso-loading" />;
    } else {
        result = <LoginPanel />;
    }
    return result;
}

export default SsoLogin;
